var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoadsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M0 13C0 5.8203 5.8203 0 13 0h34c7.1797 0 13 5.8203 13 13v34c0 7.1797-5.8203 13-13 13H13C5.8203 60 0 54.1797 0 47V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-loads-app-background)",
    fillRule: "evenodd",
    d: "M25.1727 27.1755c0 .2465.2054.4108.4109.4108h18.8165l-9.3672 9.3672c-.1643.1643-.3697.2465-.5752.2465H16.4218c-.4519 0-.8217-.3698-.8217-.8217V18.2191c0-.2054.0822-.4108.2465-.5752l9.3261-9.244v18.7756zm9.6137-1.1915v-7.6006c0-.2054-.1643-.3697-.4108-.3697H26.775V8.4h16.8034c.4519 0 .8217.3697.8217.8217V25.984h-9.6137z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.0972 51.8h5.423v-1.837h-3.498V43.77h-1.925v8.03zm9.8674.11c2.31 0 4.114-1.837 4.114-4.125 0-2.277-1.826-4.125-4.114-4.125s-4.103 1.848-4.103 4.125c0 2.288 1.815 4.125 4.103 4.125zm0-1.892c-1.254 0-2.167-1.012-2.167-2.233 0-1.232.924-2.244 2.167-2.244 1.243 0 2.189 1.012 2.189 2.244 0 1.221-.924 2.233-2.189 2.233zm4.0748 1.782h1.936l.418-1.199h3.069l.418 1.199h1.947l-2.97-8.03h-1.848l-2.97 8.03zm3.894-5.566l.946 2.695h-1.892l.946-2.695zm4.572 5.566h2.882c2.387 0 4.147-1.727 4.147-4.015 0-2.277-1.683-4.015-4.18-4.015h-2.849v8.03zm2.761-6.248c1.507 0 2.332.968 2.332 2.233 0 1.243-.891 2.222-2.299 2.222h-.88v-4.455h.847zm8.1899 6.358c1.771 0 3.058-1.111 3.058-2.629 0-1.727-1.419-2.145-2.618-2.42-.968-.231-1.628-.33-1.628-.825 0-.363.308-.715.957-.715.803 0 1.331.352 1.705.946l1.54-1.199c-.858-.924-1.727-1.43-3.201-1.43-1.716 0-2.937 1.067-2.937 2.464 0 1.65 1.364 2.079 2.53 2.343 1.133.275 1.661.385 1.661.924 0 .44-.352.748-1.001.748-.902 0-1.529-.418-2.002-1.133l-1.65 1.32c.759.913 1.804 1.606 3.586 1.606z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-loads-app-background",
    x1: 44.4001,
    x2: 15.6001,
    y1: 8.4,
    y2: 37.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#759298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadsApp);
export default __webpack_public_path__ + "static/media/icon_loads_app.e908e7cbcbe2adf873b88542b05c6f92.svg";
export { ForwardRef as ReactComponent };